<template>
  <div class="reg-success-label">
    <slot name="before"/>
    <div class="signin-text text-center" style="margin-bottom: 10px">Для входа в личный кабинет введите код из SMS</div>
    <div class="row">
      <div class="col-md-12 form-signin">
        <div :class="acceptTokenInputClass">
          <input
            style="text-align: center"
            type="text"
            class="form-control"
            placeholder="Код"
            v-model="acceptToken"
          />
          <span v-if="hasErrors" class="help-block">{{ error }}</span>
        </div>
        <div class="form-group">
          <input
            type="submit"
            class="btn btn-block btn-success"
            value="Отправить"
            @click="submit"
          />
        </div>
      </div>
    </div>
    <slot name="after"/>
  </div>
</template>

<script>
import { AuthAcceptMethods } from '../../enums/AuthAcceptMethods'
import { ApiClient } from '../../helpers/api-client/ApiClient'
import { ResponseStatuses } from '../../enums/ResponseStatuses'

export default {
  name: 'AcceptLoginPhone',

  props: {
    userId: Number
  },

  data: () => ({
    acceptToken: null,
    errors: []
  }),

  computed: {
    error () {
      return this.errors.join('\n')
    },

    hasErrors () {
      return this.errors.length > 0
    },

    acceptTokenInputClass () {
      if (this.hasErrors) {
        return 'form-group has-error'
      }

      return 'form-group'
    }
  },

  methods: {
    submit () {
      const form = {
        accept_method: AuthAcceptMethods.Phone,
        user_id: this.userId,
        accept_token: this.acceptToken
      }

      ApiClient.acceptLogin(form)
        .then(async (response) => {
          const data = response.data
          this.errors = data.errors

          if (data.status === ResponseStatuses.Success) {
            this.$store.dispatch('authorize', data.data)

            this.$router.push('/')
          }
        })
    }
  }
}
</script>
